// src/pages/user/Transactions.js
import React from "react";
import UserTransactions from "../../components/User/UserTransactions";

export default function UserTransactionsPage() {
  return <UserTransactions />;
}
